import React, { useContext, useState } from "react";
import SignupFormStyles from "../../Styles/SignUp/SignUpForm.module.css";
import Input from "../../Common/Input.component/Input";
import Button from "../../Common/Button.component/Button";
import { postRequest } from "../../helper/CustomPost";
import { ContextForClient } from "../../Context_file/ClientContext";
import Links from "../../Common/Link.component/Link";
import { withRouter } from "react-router";

const LoginForm = ({ history }) => {
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [, dispatch] = useContext(ContextForClient);

  const { container, form } = SignupFormStyles;

  const handleLoginForm = async (e) => {
    e.preventDefault();
    const url = "member/login",
      storage = "loginUser";

    const data = { email, password };
    await postRequest({ data, dispatch, url, history, storage });
    setemail("");
    setpassword("");
  };

  return (
    <div className={`container ${container}`}>
      <form
        className={`form-group ${form}`}
        onSubmit={(ref) => handleLoginForm(ref)}
      >
        <Input
          type="email"
          name="email"
          placeholder="email"
          value={email}
          className="form-control"
          onChange={(ref) => setemail(ref.target.value)}
        />
        <Input
          type="password"
          name="password"
          placeholder="password"
          className="form-control"
          value={password}
          onChange={(ref) => setpassword(ref.target.value)}
        />
        <Button
          text="Log In"
          className="btn btn-md  w-100 float-right"
          backgroundColor="#000"
          minWidth="150px"
          outline="none"
        />
        <Links
          url="/register"
          text="Not yet a member sign up"
          textDecoration="underline"
          className="text-end"
        />
      </form>
    </div>
  );
};

export default withRouter(LoginForm);
